import { GatsbyImageProps } from 'gatsby-plugin-image';
import React from 'react';
import { render } from 'storyblok-rich-text-react-renderer';

import { Content, Grid, Image, CaseStudyBanner, QuoteBreaker, Section, Lead } from '../../index';
import * as styles from './Post.module.css';
import H from '@tracsis/library/src/components/Typography/H';
import P from '@tracsis/library/src/components/Typography/P';

const PostCaseStudy = ({
	title,
	intro,
	content_summary,
	canonicalSite,
	content_detail,
	breakout_image,
	breakout_image_alt,
	content_special,
	breakout_image_2,
	breakout_image_2_alt,
	content_special_2,
	section_4_column_1,
	section_4_column_2,
	content_special_3,
	content_results,
	content_featured,
	featured_image,
	featured_alt,
	quote,
	quote_author,
	quote_client,
	quote_image,
	snippet,
	isGroup = false,
}: {
	title?: string;
	intro?: any;
	content_summary?: any;
	canonicalSite: { label: string; tag: string; to: string; uuid: string };

	// Content Section 1 	
	content_detail?: any;

	// Content Section 2 	
	breakout_image?: GatsbyImageProps | string | undefined;
	breakout_image_alt?: string;
	content_special?: any;

	// Content Section 3 
	breakout_image_2?: GatsbyImageProps | string | undefined;
	breakout_image_2_alt?: string;
	content_special_2?: any;

	// Content Section 4
	section_4_column_1?: any;
	section_4_column_2?: any;

	// Content Legacy
	content_special_3?: any;
	content_results?: any;

	content_featured?: any;
	featured_image?: GatsbyImageProps | string | undefined;
	featured_alt?: string;

	quote?: any;
	quote_author?: string;
	quote_client?: string;
	quote_image?: GatsbyImageProps | string | undefined;

	// Snippet
	snippet?: React.ReactNode;

	isGroup?: boolean;
}) => {
	const breakout_1 = (breakout_image !== '' && breakout_image !== null);
	const breakout_2 = (breakout_image_2 !== '' && breakout_image_2 !== null);
	return (
		<article className="post">
			<Section pull gap="md">
				{snippet}
				<div className={styles.caseStudyLead}>
					<H level={1} spacing="lg">
						{title}
					</H>
					{render(intro) !== null && (<P>{render(intro)}</P>)}
				</div>

				{isGroup || render(content_summary) !== null && (
					<Content clamp>
						{isGroup && canonicalSite && (
							<CaseStudyBanner canonicalSite={canonicalSite} />
						)}
						{render(content_summary) !== null && (
							<div className="rhythm">{render(content_summary)}</div>
						)}
					</Content>
				)}
			</Section>

			{render(content_detail) !== null && (
				<Section pull>
					<Content clamp>
						<div className="rhythm">{render(content_detail)}</div>
					</Content>
				</Section>
			)}
			{render(content_special) !== null && (
				<Section
					breakoutImage={breakout_1 ? true : false}
					background={breakout_1 ? "lightBlue" : "white"}
				>
					{breakout_1 == true && (
						<div className={styles.breakoutImage}>
							<Image image={`${breakout_image}/m/1136x450`} alt={breakout_image_alt} />
						</div>
					)}
					<div className={breakout_1 ? styles.contentWrapper : null}>
						<Content clamp>
							<div className="rhythm">{render(content_special)}</div>
						</Content>
					</div>
				</Section>
			)}
			{render(content_special_2) !== null && (
				<Section
					breakoutImage={breakout_2 ? true : false}
					background={breakout_2 ? "lightBlue" : "white"}
				>
					{breakout_2 && (
						<div className={styles.breakoutImage}>
							<Image image={`${breakout_image_2}/m/1136x450`} alt={breakout_image_2_alt} />
						</div>
					)}
					<div className={breakout_2 ? styles.contentWrapper : null}>
						<Content clamp>
							<div className="rhythm">{render(content_special_2)}</div>
						</Content>
					</div>
				</Section>
			)}
			{render(section_4_column_1) !== null && (
				<Section>
					<div className={styles.featuredData}>
						<div className={styles.accent}></div>
						<div className={styles.box}>
							<Grid>
								{render(section_4_column_1) !== null && (
									<Content>
										<div className="rhythm">{render(section_4_column_1)}</div>
									</Content>
								)}
								{render(section_4_column_2) !== null && (
									<Content>
										<div className="rhythm data-column">{render(section_4_column_2)}</div>
									</Content>
								)}
							</Grid>
						</div>
					</div>
				</Section>
			)}
			{render(content_results) !== null && (
				<Section>
					<Content clamp>
						<div className="rhythm">{render(content_results)}</div>
					</Content>
				</Section>
			)}
			{render(content_special_3) !== null && (
				<Section>
					<Content clamp>
						<div className="rhythm">{render(content_special_3)}</div>
					</Content>
				</Section>
			)}
			{render(content_featured) !== null && (
				<Section>
					<Content theme="deep">
						<div className={styles.featured}>
							<div className="rhythm">{render(content_featured)}</div>
							<div>
								<Image image={`${featured_image}/m/640x460`} alt={featured_alt} />
							</div>
						</div>
					</Content>
				</Section>
			)}
			{render(quote) !== null && (
				<Section>
					<QuoteBreaker variant="altaccent">
						<QuoteBreaker.Quote>{render(quote)}</QuoteBreaker.Quote>
						<QuoteBreaker.Citation>
							<strong>{quote_author}</strong>,<br />
							{quote_client}
						</QuoteBreaker.Citation>
					</QuoteBreaker>
				</Section>
			)}
		</article>
	);
};

export default PostCaseStudy;